import { Carousel, CarouselProps } from '@design-system/carousel';
import { ExtendableImage } from '@design-system/extendable-image';
import { PageBlock } from '@design-system/page-block';
import React, { forwardRef } from 'react';

import { CarouselImage, PIMAssetsCarouselProps } from './models';

const imageElementsMapper = (images: CarouselImage[]): CarouselProps['items'] =>
  images.map(({ key, image }) => ({
    children: <ExtendableImage key={key} {...image} />,
  }));

const PIMAssetsCarousel = forwardRef<HTMLDivElement, PIMAssetsCarouselProps>(
  (
    { pageBlockUI, componentId, carousel: { images, ...carouselProps } },
    ref
  ) => (
    <PageBlock
      {...pageBlockUI}
      id={componentId}
      className="gth-pim-assets-carousel"
      ref={ref}
    >
      <Carousel {...carouselProps} items={imageElementsMapper(images)} />
    </PageBlock>
  )
);

export default PIMAssetsCarousel;
